import each from 'lodash/each';
import omit from 'lodash/omit';

import {
  notifyErrorMaybeLostData
} from './misc.js';

import {
  sendRequest
} from 'zoomforth_zfutils/xhr_tools.js';

import {
  toStructuredAsset
} from 'zoomforth_codesbane_viewer/transformers/transform_standard_page_content_item.js';

import { 
  getSectionForContent,
  getContentUuidsForAssetId
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  updateOrderedContentSectionAfterEncoding
} from './sections.ordered_content.js';

import {
  updateGridSectionAfterEncoding
} from './sections.grid.js';

import {
  isOrderedContentSection,
  isGridPositionsContentSection
} from 'zoomforth_codesbane_viewer/lib/sections.js';

export const updateAssetAfterEncoding = (assetType, assetId)=>
  (dispatch, getState)=> {
    sendRequest({
      url: `/api/assets/${assetType}-${assetId}`,
      method: 'GET',
      onSuccess: (receivedData)=> {
        dispatch(updateAssetData(toStructuredAsset(receivedData)));

        const contentUuids = getContentUuidsForAssetId(getState(), assetId);

        each(contentUuids, (uuid) => {
          const section = getSectionForContent(getState(), uuid);

          if (isGridPositionsContentSection(section)) {
            dispatch(updateGridSectionAfterEncoding(section, uuid));
          } else if (isOrderedContentSection(section)) {
            dispatch(updateOrderedContentSectionAfterEncoding(section, uuid));
          }
        });
      },
      onError: ({ status, responseText })=> {
        dispatch(notifyErrorMaybeLostData(status, responseText));
      }
    });
  };

export const updateAssetData = (asset) => {
  return { type: 'UPDATE_ASSET_DATA', asset };
};

export const setAndUpdateAssetData = (asset) =>
  (dispatch) => {
    var url = `/api/assets/${asset.assetType}-${asset.assetId}`;

    const assetKeysToOmit = [
      // subtitles are handled in the media library and should not be patched to
      // the server from the site editor
      'subtitles'
    ];

    const sanitizedAsset = omit(asset, assetKeysToOmit);

    sendRequest({
      url: url,
      method: 'PATCH',
      params: sanitizedAsset,
      onSuccess: (receivedData)=> {
        dispatch(updateAssetData(toStructuredAsset(receivedData)));
      },
      onError: ({ status, responseText })=> {
        dispatch(notifyErrorMaybeLostData(status, responseText));
      }
    });
  };

export const fetchAndUpdateAssetData = (assetType, assetId)=>
  (dispatch)=> {
    var url = `/api/assets/${assetType}-${assetId}`;

    // @TODO forms are served from a different API than other assets. We should
    // allow forms to be fetched from assets API or find a better
    // approach than special casing this single asset type.
    if (assetType === 'form') {
      url = `/api/forms/${assetId}`;
    }

    sendRequest({
      url: url,
      method: 'GET',
      onSuccess: (receivedData)=> {
        dispatch(updateAssetData(toStructuredAsset(receivedData)));
      },
      onError: ({ status, responseText })=> {
        dispatch(notifyErrorMaybeLostData(status, responseText));
      }
    });
  };
